module.exports = __webpack_public_path__ + "static/media/ftue_naomi.32ff53ad.png";